export const SET_PATIENTS = "SET_PATIENTS";
export const SET_EMAIL_TEMPLATE = "SET_EMAIL_TEMPLATE";
export const SET_PROMPT = "SET_PROMPT";
export const SET_CUSTOM_EMAIL_TEMPLATE = "SET_CUSTOM_EMAIL_TEMPLATE";
export const SET_PATIENT_INVITE_LOGS = "SET_PATIENT_INVITE_LOGS";
